import React from 'react';
import BannerPageTitle from "../Components/UIcomponents/BannerPageTitle";
import { playingConditionHtml } from "./playingConditionData";

function PlayingCondition() {
    return (
        <div style={{ background: '#f4f6fa', minHeight: '100vh', paddingBottom: '4rem' }}>
            <BannerPageTitle 
                title='Playing Condition' 
                subtitle='Guidelines and rules governing BTCL matches'
            />
            <div style={{ 
                maxWidth: '900px', 
                margin: '-40px auto 0 auto', 
                padding: '3rem 2.5rem', 
                minHeight: '50vh', 
                background: '#ffffff', 
                borderRadius: '12px', 
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                position: 'relative',
                zIndex: 10,
                borderTop: '4px solid var(--blue)'
            }}>
                <div 
                    dangerouslySetInnerHTML={{ __html: playingConditionHtml }}
                    style={{ 
                        font: '400 1.1rem/1.8 var(--fontBody), sans-serif', 
                        color: '#333',
                        textAlign: 'justify'
                    }}
                />
            </div>
        </div>
    );
}

export default PlayingCondition;
